module.exports = __webpack_public_path__ + "img/IMG_8689.ee7df87e.jpg";